import { render } from "./GainsLosses.vue?vue&type=template&id=64d65aba&scoped=true"
import script from "./GainsLosses.vue?vue&type=script&lang=js"
export * from "./GainsLosses.vue?vue&type=script&lang=js"

import "./GainsLosses.vue?vue&type=style&index=0&id=64d65aba&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d65aba"]])

export default __exports__